import 'animate.css';
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ArrowBarDown, ArrowRightCircle } from 'react-bootstrap-icons';
import TrackVisibility from 'react-on-screen';
import headerImg from "../assets/img/header-img.png";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const toRotate = [ "Web Developer", "Game Developer", "IT technologist" ];
  const period = 2000;
  
  const handleDownload = () => {
    const fileId = '1Ulz4cnX5SmKbA89RlWYRWkpNeQ3HNsCO';
    const downloadLink = `https://drive.google.com/uc?id=${fileId}`;
    window.location.href = downloadLink;
  }

  const handleConnect = () => {
    window.open('https://discord.com/users/582382293838987265', '_blank');
  }

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  })

  const tick = () => {
  let i = loopNum % toRotate.length;
  let fullText = toRotate[i];
  let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

  setText(updatedText);

  if (isDeleting) {
    setDelta(prevDelta => prevDelta / 2);
  }

  if (!isDeleting && updatedText === fullText) {
    setIsDeleting(true);
    setDelta(period);
  } else if (isDeleting && updatedText === '') {
    setIsDeleting(false);
    setLoopNum(loopNum + 1);
    setDelta(500);
  }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>{`Hi! I'm Karol`} <br/><span className="txt-rotate" dataperiod="1000" data-rotate='[ "Frontend Developer", "Game Developer", "UI/UX Designer" ]'><span className="wrap">{text}</span></span></h1>
                  <p>Web Developer and Software Engineer in training with a passion for video game development and UI/UX design.
                  I am a responsible, creative and proactive person with autonomous learning, collaborative work.</p>
              <div className="button-container">
                <button onClick={handleConnect}>Let’s Connect <ArrowRightCircle size={25} /></button>
                <button className="download" onClick={handleDownload}>Download CV <ArrowBarDown size={25} /></button>
              </div>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}